/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unit: NonNullable<unknown> }} My_Grower_Report_Unit_HeadingInputs */

const vi_my_grower_report_unit_heading = /** @type {(inputs: My_Grower_Report_Unit_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn vị: ${i?.unit}`)
};

/**

* @param {My_Grower_Report_Unit_HeadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_unit_heading = /** @type {((inputs: My_Grower_Report_Unit_HeadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Unit_HeadingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_unit_heading(inputs)
});